import { Component, Input, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { HourAverageDto } from '../../../data/models/hour-average-dto';
import { LineDetailsDto } from '../../../data/models/line-details-dto';
import { AccountLineSubjectService } from '../../../services/account-line-subject.service';
import { AvgDelayDropService } from '../../../services/avg-delay-drop.service';
import { CommonGlobalService } from '../../../services/common-global.service';

@Component({
  selector: 'app-cc-line-delay-drop-graph',
  templateUrl: './cc-line-delay-drop-graph.component.html',
  styleUrls: ['./cc-line-delay-drop-graph.component.scss'],
  providers: [MessageService]
})
export class CcLineDelayDropGraphComponent implements OnInit{
  @Input() lineId: number;
  @Input() ipAddress: string;
  @Input() isMonitored: boolean;

  lineGraphsData: HourAverageDto[]=[];

  delayChart: any;
  delayOptions: any ;

  dropChart: any;
  dropOptions: any ;

  loader :boolean = true;
  changesSubscriber: Subscription;

  tempEmptyarray: any[] = [];
  constructor(private avgDelayDropService: AvgDelayDropService, private messageService: MessageService,
    private accountLineChangesService: AccountLineSubjectService, private commonGlobalServcie: CommonGlobalService) { }

  ngOnInit() {
    //if (!this.lineId || !this.ipAddress)
    //  this.accountLineChangesObserver();
    /*    this.drawDelayGraph();*/
    //this.delayChart = new ApexCharts(document.getElementById('delayGraph'), this.delayOptions);
    //this.delayChart.render();

    //this.drawDropGraph();
    //this.dropChart = new ApexCharts(document.getElementById('droppedGraph'), this.dropOptions);
    //this.dropChart.render();

    this.isMonitored
      ? (this.lineId && this.ipAddress) ? this.getGraphData(this.lineId, this.ipAddress) : this.loader = false
      : this.draw();
    this.commonGlobalServcie.ipAddress = this.ipAddress;

  }
  ngOnChanges() {
    this.isMonitored
      ? (this.lineId && this.ipAddress) ? this.getGraphData(this.lineId, this.ipAddress) : this.loader = false
      : this.draw();
  }
  ///`LineDetails/get-Line-monitor-digest-graph/`
  getGraphData(lineId: number, IpAddress:string) {
    this.loader = true;
    this.avgDelayDropService.getLineDelayDropGraphData(lineId, IpAddress).subscribe((res: HourAverageDto[]) => {
      if (res) {
        this.lineGraphsData = res;

        this.prepareDelayData(res.map(d => d.delayAverage));
        this.prepareDroppedData(res.map(r => r.dropAverage));
      }
      this.loader = false;
    }, (error) => {
      this.loader = false;
      this.messageService.add({ severity: 'error', summary: 'Line Delay Drop Data', detail: 'retrieving line graphs information' });
    })
  }
  prepareDelayData(delay: any[]) {

    this.delayOptions = {
      series: [{
        name: 'Delay Avg',
        data: delay //this.outTraffic ////
      }],
      chart: {
        height: 200,
        type: "line",
        //background: 'green',
        /*foreColor: 'white',*/
        toolbar: {
          show: false,
        },
        style: {
          //colors: "white"
        },
        
      },
      markers: {
        size : 3
      },
      
      grid: {
        show: true,
        style: {
          colors: ["#FF0000"]
        },
      },
      /*colors: ['#FFFFFF'],*/
      dataLabels: {
        enabled: false,
        
      },
      //title: {
      //  text: "Delay (24H)", // 'Delay (24H)',
      //  //offsetY: -5,
      //  //style: {
      //  //  fontSize: '14px',
      //  //  fontWeight: 'normal',
      //  //  //fontFamily: undefined,
      //  //  /*color: '#FFFFFF'*/
      //  //},
      //},
      stroke: {
        //curve: 'smooth',
        width: 3,
      },
      tooltip: {
        x: {
          show: true,
          
          format: 'dd MMM yyyy  HH:mm',
          formatter:undefined
        },
        y: {
          title: {
            formatter: function (value1, value2) {
              return;
            }
          }
        }
      },
      xaxis: {

        type: "datetime",
        axisBorder: {
          show: true,
        },
        axisTicks: {
          show: false,
        },
        labels: {
          show : true ,
          //style:
          //{
          //  colors: "red",
          //},
          
          datetimeUTC: false,
        },
        categories: this.lineGraphsData.map(x => x.hourTime),
        tooltip: {
          enabled: false // Disable the x-axis tooltip
        }
      },
      yaxis: {

        labels: {
          show: true,
        }
      },
      toolbar: {
        show: true,
      },
      noData: {
        text: 'No Data Found',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
      }
    };
    this.drawDelayGraph();
  } 

  prepareDroppedData(dropped: any[]) {
      this.dropOptions = {
      series: [{
        name: 'Drop Avg',
        data: dropped //this.outTraffic ////
      }],
      chart: {
        height: 200,
        type: "area",
        toolbar: {
          show: false,
        },
      },
        colors: ['#ff0000'],
      dataLabels: {
        enabled: false
      },
      //title: {
      //  text: 'Dropping (24H)'
      //},
      stroke: {
        width: 3,
      },
      tooltip: {
        x: {
          show:true,
          format: 'dd MMM yyyy  HH:mm',
          formatter: undefined,
        },
        y: {
          title: {
            formatter: function (value1, value2) {
              return;
            }
          }
        }
      },
      xaxis: {
        type: "datetime",
        labels: {
          datetimeUTC: false,
        },
        categories: this.lineGraphsData.map(x => x.hourTime),
        tooltip: {
          enabled: false // Disable the x-axis tooltip
        }
      },
        yaxis: {
         
          title: {
            text: 'Percentage'
          },
          decimalsInFloat: 0,
          labels: {
           
          }
      },
      toolbar: {
        show: true,
        },
      noData: {
          text: 'No Data Found',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
      }
    };
    this.drawDropGraph();
  }
  drawDelayGraph() {
    this.loader = false;
    this.destroyDelayChartEvent();
    this.delayChart = new ApexCharts(document.getElementById('delayGraph'), this.delayOptions);
    this.delayChart.render();


  }
  drawDropGraph() {
    this.loader = false;
    this.destroyDropChartEvent();
    this.dropChart = new ApexCharts(document.getElementById('droppedGraph'), this.dropOptions);
    this.dropChart.render();

  }

  destroyDelayChartEvent() {
    if (this.delayChart instanceof ApexCharts)
      (<ApexCharts>this.delayChart).destroy();
  }

  destroyDropChartEvent() {
    if (this.dropChart instanceof ApexCharts)
      (<ApexCharts>this.dropChart).destroy();
  }

  accountLineChangesObserver() {
    this.changesSubscriber = this.accountLineChangesService.notifyChangesInSelectedLine.subscribe((res: LineDetailsDto) => {
      if (res) {
        //get data again
        this.lineId = res.id;
        this.ipAddress = res.ipAddress;
        this.getGraphData(res.id, res.ipAddress);
      }
    }, (error) => {
      this.messageService.add({ severity: 'error', summary: 'Account Line Changes Observer', detail: 'Could not retrieve line Sammry data' });
    })
  }

  draw() {
    this.prepareDelayData(this.tempEmptyarray);
    this.prepareDroppedData(this.tempEmptyarray);
  }

  ngOnDestroy() {
    //if (this.changesSubscriber)
    //  this.changesSubscriber.unsubscribe();
  }
}
